import { render, staticRenderFns } from "./Deceased.vue?vue&type=template&id=04c8854c&"
import script from "./Deceased.vue?vue&type=script&lang=js&"
export * from "./Deceased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports